<p>quote-accept works!</p>
